import React from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/elements/forms/TextInput";
import TextInputBox from "../../../components/elements/forms/TextInputBox";
import SelectDropdown from "../../../components/elements/forms/Select";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import { usePretest } from "../hooks/useQuestions";

interface Props {
  mode?: string;
  id?: string;
}

const CreateQuestionsAssessment: React.FC<Props> = ({ mode, id }) => {
  const navigate = useNavigate();
  const {
    data,
    error,
    loading,
    editMode,
    onChangeHandler,
    onChangeSelect,
    updateQuestion,
    addQuestion,
    removeQuestion,
    onChangeTextbox,
    onSubmit_,
  } = usePretest("assessment", { mode, id });
  // const { onSubmit_ } = useAssessment();

  return (
    <div className="w-full py-5">
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex border-b border-border text-20">
          <div
            onClick={() => navigate(`/pretest-create`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[600]">Add Pretest Questions</p>
          </div>
          <div
            onClick={() => navigate(`/assessment-create`)}
            className="border-b-[3px] border-secondary pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Add Assessment Questions</p>
          </div>
          {/* <div
            onClick={() => navigate(`/pretests`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[600]">Pretest Questions</p>
          </div>
          <div
            onClick={() => navigate(`/assessments`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[600]">Assessment Questions</p>
          </div> */}
        </div>
        <div className="rounded-10 bg-white px-4 py-5 mt-5">
          <TextInput
            label="Assessment Title"
            placeholder="Enter assessment title"
            name="jobTitle"
            value={data.jobTitle}
            error={error.jobTitle}
            onChange={onChangeHandler}
            required
          />
          <TextInputBox
            label="Description"
            rows={4}
            placeholder="Enter description"
            name="description"
            value={data.description}
            // status={error.description}
            onChange={onChangeTextbox}
            // required={true}
            min={3}
          />

          {/* <SelectDropdown
            items={[
              { id: "guided", name: "Guided" },
              { id: "autonomous", name: "Autonomous" },
            ]}
            name="mode"
            label="Question Mode"
            value={data.mode || "guided"}
            onChange={onChangeSelect}
            required
          /> */}

          {data.mode === "autonomous" ? (
            <SelectDropdown
              items={Array.from({ length: 15 }, (_, i) => ({
                id: (i + 1).toString(),
                name: `${i + 1} Question${i > 0 ? "s" : ""}`,
              }))}
              name="numQuestions"
              label="Number of Questions"
              value={data.numQuestions?.toString() || ""}
              onChange={onChangeSelect}
              required
            />
          ) : (
            data.questions.map((question, index) => (
              <div key={index} className="w-full">
                <TextInputBox
                  rows={4}
                  showIcon={true}
                  label={`Questions ${index + 1}`}
                  placeholder="Enter question"
                  name={`question-${index}`}
                  value={question}
                  error={error.questions}
                  onChange={(e) => {
                    updateQuestion(index, e.target.value);
                  }}
                  add={addQuestion}
                  remove={
                    data.questions.length > 1
                      ? () => removeQuestion(index)
                      : undefined
                  }
                  required
                />
              </div>
            ))
          )}

          <SelectDropdown
            items={[
              { id: "15", name: "15mins" },
              { id: "20", name: "20mins" },
              { id: "25", name: "25mins" },
              { id: "30", name: "30mins" },
              { id: "35", name: "35mins" },
              { id: "40", name: "40mins" },
              { id: "45", name: "45mins" },
            ]}
            name="duration"
            label="Duration"
            value={data.duration || ""}
            onChange={onChangeSelect}
            error={error.duration}
            required
          />

          {/* {data.questionCategory === "Pretest" ? (
            <SubmitButton
              title="Create"
              onSubmitHandler={onSubmit}
              loading={loading}
              className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
            />
          ) : data.questionCategory === "Assessment" ? ( */}
          <SubmitButton
            title={editMode ? "Update Assessment" : "Create Assessment"}
            onSubmitHandler={onSubmit_}
            loading={loading}
            className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
          />
          {/* ) : (
            <SubmitButton
              title="Create"
              className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
            />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default CreateQuestionsAssessment;
